import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/RegisterPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const pathPrefix = "page.join-us.register";
  const routerKey = "form.register";
  const titleKey = `${pathPrefix}.banner.title`;

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          link: router[routerKey]["en"],
        },
      },
      router: router[routerKey],
      content: [
        { component: "RegisterPageBannerSection", props: { className: "", pathPrefix } },
        { component: "RegisterPageFormSection", props: { className: "py-4 py-md-5", pathPrefix } },
      ],
      footer: {
        showForm: false,
      },
    },
  };
}
